const viewportUnits = () => {
	const rootFontSize = parseFloat(
		getComputedStyle(document.documentElement).fontSize
	);
	const vh = window.innerHeight;
	const vw = window.innerWidth;

	document.documentElement.style.setProperty(
		'--vh',
		`${(vh * 0.01) / rootFontSize}rem`
	);

	document.documentElement.style.setProperty(
		'--vw',
		`${(vw * 0.01) / rootFontSize}rem`
	);
};

export default viewportUnits;
